<template>
  <p>
    Agregamos automáticamente su información de contacto al bloque de pie de página. Se requiere
    esta información en todas los envíos masivos para cumplir con la
    <a href="http://" target="_blank" rel="noopener noreferrer">
      Ley CAN-SPAM y la ley internacional de spam.
    </a>
  </p>

  <a-form layout="vertical" ref="formRef" :model="formState">
    <a-form-item name="year" label="Año actual" required>
      <a-input v-model:value="formState.year" placeholder="Escribir año actual" />
    </a-form-item>

    <a-form-item name="entityName" label="Nombre de tu empresa" required>
      <a-input v-model:value="formState.entityName" placeholder="Escribir nombre de tu empresa" />
    </a-form-item>

    <a-form-item name="email" label="Correo eletrónico de tu empresa" required>
      <a-input v-model:value="formState.email" placeholder="Escribir correo eletrónico" />
    </a-form-item>

    <ColorPicker
      name="backgroundColor"
      label="Color"
      v-model:color="formState.backgroundColor"
      :default-colors="defaultColors"
      :required="false"
      animated
      description="Elige un color que constraste con la marca de tu empresa"
    />
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { FormInstance } from "ant-design-vue";

import { FooterItem } from "@/@types/flows/emailTemplates/items";
import { defaultColors } from "@/app/flows/emailTemplates/utils/colors";

import ColorPicker from "@/app/shared/components/pickers/ColorPicker.vue";

const props = defineProps<{ item: FooterItem }>();

const formRef = ref<FormInstance>();
const formState: Partial<FooterItem> = reactive({
  year: props.item.year,
  entityName: props.item.entityName,
  email: props.item.email,
  backgroundColor: props.item.backgroundColor,
});

const getValidatedFormState = async () => {
  await formRef.value?.validateFields();

  return formState;
};

defineExpose({ getValidatedFormState });
</script>

<style scoped lang="sass"></style>
